export default "__VITE_ASSET__B4y4a57V__"